
























import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';

export enum SwitchPredefinedStyle {
  Grey = 'switch--grey-style',
  Secondary = 'switch--secondary-style',
}

@Component({})
export default class SwitchButton extends Vue {
  @Model('change', { type: Boolean }) readonly active!: boolean;
  @Prop({ default: '' }) private switchLabel!: string;
  @Prop({ default: '' }) private switchText!: string;
  @Prop({ default: '' }) private switchError!: string;
  @Prop({ default: SwitchPredefinedStyle.Secondary })
  private switchPredefinedStyle!: SwitchPredefinedStyle;

  get hasLabel() {
    return this.switchLabel.length > 0;
  }

  get hasError() {
    return this.switchError !== '';
  }

  private hideError() {
    this.$emit('hide-error');
  }

  private handleClick() {
    this.hideError();
    this.$emit('change', !this.active);
    this.$emit('switch-btn-click', !this.active);
  }
}
